import React, { Component } from 'react'

import Header from './components/Header'
import ImageSection from './components/ImageSection'
import IntroSection from './components/IntroSection/index'
import FormSection from './components/FormSection/index'
import Footer from './components/Footer/index'

import './App.css'

class App extends Component {
  render() {
    return (
      <div className="App">
        <Header />
        <ImageSection />
        <IntroSection />
        <FormSection />
        <Footer />
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js